module.exports = __webpack_public_path__ + "static/media/pla_white_strew1.43364d97.png";